export default {
  error_title: 'Error',
  // TKT-2149: strict location settings (ExtraSettings)
  mock_toggle_label: 'Enable strict location validation (blocks apps that alter the GPS).',
  mock_disable_confirm: 'Are you sure you want to disable strict location validation? Users will be able to continue with an altered GPS.',
  mock_admin_only: 'Only an organization administrator can change strict location validation.',
  mock_invalid_enabled: 'The strict location validation value is not valid. Reload the page and try again.',
  report_title: 'Download the Strict Location Report',
  report_date: 'Date',
  report_from: 'Start',
  report_to: 'End',
  report_close: 'Close',
  report_download: 'Download',
  report_invalid_dates: 'Select a valid start date and end date.',
  report_from_after_to: 'The start date cannot be later than the end date.',
  report_admin_only: 'Only an organization administrator can download this report.',
  report_error: 'The report could not be generated. Please try again.',
  mock_notify_title: 'Additional Recipients',
  mock_notify_hint: 'Select another role to notify alerts (Optional)',
  mock_notify_placeholder: 'Select a role..',
  mock_notify_admin_only: 'Only the organization administrator can change the additional recipients.',
  mock_notify_invalid_role: 'The selected role is no longer available. Choose another role of the organization.',
  report_end_after_today: 'The end date cannot be later than today.',
  settings_save_error: 'The settings could not be saved. Please try again.',
  mock_blocked_title: 'This activity has been blocked',
  mock_blocked: 'We detected that you are using a tool to hide where you are connecting from.',
  mock_blocked_note: 'This activity will be blocked.',
  mock_blocked_ok: 'Got it',
  blocked_out_of_area: 'You are not at the right location to fill out this form. Get closer to the assigned site and try again.',
  blocked_unavailable: 'We could not get your location. Check that GPS is on and try again.',
  blocked_dismiss: 'Got it',
  permission_denied: 'The device did not allow access to your location. Please check the permissions.',
  precise_location_required: 'We need your precise location. Open the app permissions and switch "Approximate" to "Precise".',
  position_unavailable: 'We could not get your location. Check that GPS is on and try again.',
  timeout: 'The GPS is taking too long to respond.'
}
